import React, { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { useResetRecoilState, useSetRecoilState } from 'recoil'

import { TYPE_SECURITY } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useSecurityQueryData } from '@/shared/hooks/reactquery'
import { SecurityNumState, SecurityTranIdState } from '@/shared/store'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'
import {
  ModalConfirmContent,
  ModalDefaultTitle,
  NoticeContent,
  NoticeWrap,
} from '@/styles/common/modal'

const NoticeModal = (props: any) => {
  const { isOpen, ClickFunc } = props
  const { pathname } = useLocation()
  const ResetSecurityNumState = useResetRecoilState(SecurityNumState)
  const setSecurityTranId = useSetRecoilState(SecurityTranIdState)
  const { data: SecurityData, mutate: SecurityReceive } = useSecurityQueryData(TYPE_SECURITY)
  const navigate = useNavigate()

  const NoticeConfirmFunc = () => {
    document.body.style.overflow = 'unset'
    const index =
      window.location.href.indexOf('local') > 0 || window.location.href.indexOf('dev') > 0 ? 20 : 34
    navigate(`/notice/detail/${index}`)
  }
  useEffect(() => {
    SecurityData?.Body?.TranID && setSecurityTranId(SecurityData?.Body?.TranID)
  }, [SecurityData?.Body?.TranID, SecurityReceive, setSecurityTranId])

  useEffect(() => {
    ResetSecurityNumState()
    SecurityReceive()
  }, [ResetSecurityNumState, SecurityReceive, isOpen])

  return (
    <>
      <ModalConfirmContent>
        <NoticeWrap>
          <ModalDefaultTitle>LG U+ 시스템 점검 안내</ModalDefaultTitle>
          {pathname === '/cancel' ? (
            <NoticeContent>
              LG U+ 이동통신사에서 진행하는 시스템 점검에 의해 LG U+ 이용 고객의 서비스 해지가 일시
              중단될 예정입니다.
              <br />
              <br />
              ▣ 점검 기간
              <br />
              2023년 10월 20일(금) 22:00 ~ 2023년 10월 23일(월) 08:00
              <br />
              <br />
              자세한 내용은 공지사항 확인을 부탁 드립니다.
              <br />
              <br />더 좋은 서비스로 보답하겠습니다.
            </NoticeContent>
          ) : (
            <NoticeContent>
              LG U+ 이동통신사에서 진행하는 시스템 점검에 의해 LG U+ 이용 고객의 서비스 가입/해지가
              일시 중단될 예정입니다.
              <br />
              <br />
              ▣ 점검 기간
              <br />
              2023년 10월 20일(금) 22:00 ~ 2023년 10월 23일(월) 08:00
              <br />
              <br />
              자세한 내용은 공지사항 확인을 부탁 드립니다.
              <br />
              <br />더 좋은 서비스로 보답하겠습니다.
            </NoticeContent>
          )}
        </NoticeWrap>
        <section>
          <ModalBtn bgColor={COLOR.blueGray3} onClick={ClickFunc}>
            <span>취소</span>
          </ModalBtn>
          <ModalBtn bgColor={COLOR.point1} onClick={NoticeConfirmFunc}>
            <span>자세히 보기</span>
          </ModalBtn>
        </section>
      </ModalConfirmContent>
    </>
  )
}
export default NoticeModal
